import { NavDropdown } from "react-bootstrap";
import styled from "styled-components";

export const InverseDropdown = styled.ul`
    background-color: #123;
    border-color: #080808;
    width: 250px;
    padding: 0;

    & > li > a {
        color: white;
        height: 28px;
        line-height: 23px;

        &:hover {
            color: #000 !important;
            background-color: #FFF !important;
        }
    }

    & > .divider {
        background-color: #808080;
    }

    .subarrow {
        position: absolute;
        right: 5px;
    }
`;

export const CenterMenuWrapper = styled.div`
    @media (max-width: 930px) {
        .navbar-header {
            float: none;
        }

        .navbar-left,
        .navbar-right {
            float: none !important;
        }

        .navbar-toggle {
            display: block;
        }

        .navbar-collapse {
            border-top: 1px solid transparent;
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
        }

        .navbar-fixed-top {
            top: 0;
            border-width: 0 0 1px;
        }

        .navbar-collapse.collapse {
            display: none !important;
        }

        .navbar-nav {
            float: none !important;
            margin-top: 7.5px;
        }

        .navbar-nav>li {
            float: none;
        }

        .navbar-nav>li>a {
            padding-top: 10px;
            padding-bottom: 10px;
        }

        .collapse.in {
            display: block !important;
        }
    }
    .navbar-nav > li:hover > .dropdown-menu {
        display: block;
    }

    ul li.dropdown a,
    ul li a {
        font-size: 14px !important;
    }
`;

export const NavDropdownWrapper = styled(NavDropdown)`
    & > ul > li {
        margin-left: 20px;
    }
`;

export const CenterSelectWrapper = styled.div`
    padding-top: ${p => p.isCenter ? '3px' : '5px'};
    padding-bottom: ${p => p.isCenter ? '0px' : '3px'};
`;

export const centerSelectCustomStyles = (isCenter: boolean) => ({
    container: (provided) => ({
        ...provided,
        minHeight: isCenter ? 22 : 22,
        minWidth: 200,
        height: 26
    }),
    control: (base) => ({
        ...base,
        minHeight: isCenter ? 22 : 22,
        padding: 0,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        boxShadow: '0 none',
        height: 26
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        minHeight: isCenter ? 22 : 22,
        height: 26
    }),
    clearIndicator: (provided) => ({
        ...provided,
        minHeight: isCenter ? 22 : 22,
        padding: 3
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        minHeight: isCenter ? 22 : 22,
        padding: '0px 3px'
    }),
    indicatorSeparator: () => ({
        color: "white"
    }),
    valueContainer: (provided) => ({
        ...provided,
        // top: '-1px',
        padding: isCenter ? '0px 8px' : '0px 8px',
        height: 26,
        zIndex: 5
    }),
    multiValue: (provided) => ({
        ...provided,
        marginTop: 0
    }),
    placeholder: (provided) => ({
        ...provided,
    }),
    singleValue: (provided) => ({
        ...provided,
        top: '50%',
        fontSize: 12
    }),
    menuList: (provided) => ({
        ...provided
    }),
    option: (provided) => ({
        ...provided,
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 12
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 5
    })
});